import { Link } from 'react-router-dom';

export function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/ffa58357e5a2e6b009e18c86e18059b7.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70 z-10"></div>

      <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center w-full">
        <div className="mb-6">
          <span className="inline-block px-4 py-2 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full text-white text-sm font-medium">
            전국 제조업체와 선장·선주를 직접 연결
          </span>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
          어선에 필요한 모든 물품,
          <br />
          <span className="text-amber-300 drop-shadow-md">한 곳에서 직거래</span>
        </h1>

        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed drop-shadow-sm">
          전국의 우수한 어구·갑판·기관물품 제조업체를 발견하고
          <strong className="text-amber-200 font-semibold"> 합리적인 가격</strong>에 직접 거래하세요
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <Link
            to="/products"
            className="px-8 py-4 bg-amber-500 text-white text-lg font-semibold rounded-lg hover:bg-amber-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            제품 둘러보기
          </Link>
          <Link
            to="/manufacturers"
            className="px-8 py-4 bg-white/15 backdrop-blur-sm text-white text-lg font-semibold rounded-lg hover:bg-white/25 transition-all border border-white/40 whitespace-nowrap cursor-pointer"
          >
            제조업체 찾기
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2 drop-shadow-md">150+</div>
            <div className="text-white/75 text-sm">등록 제조업체</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2 drop-shadow-md">2,500+</div>
            <div className="text-white/75 text-sm">등록 제품</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2 drop-shadow-md">800+</div>
            <div className="text-white/75 text-sm">활성 선주</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2 drop-shadow-md">98%</div>
            <div className="text-white/75 text-sm">만족도</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
